import { Route, ROUTES } from '@/configs/routes';
import { defineRouting } from 'next-intl/routing';

const locales = ['en-GB', 'no', 'de', 'sv', 'fi'] as const;

type Locale = (typeof locales)[number];

const pathnames = {
  [ROUTES.HOME]: { no: '/' },
  [ROUTES.LOGIN]: { no: '/logg-inn', fi: '/kirjaudu' },
  [ROUTES.LOGOUT]: { no: '/logg-ut', fi: '/kirjaudu-ulos' },
  [ROUTES.NOT_FOUND]: { no: '/ikke-funnet', fi: '/ei-loytynyt' },
  [ROUTES.CONSUMPTION]: { no: '/forbruk', fi: '/kulutustiedot' },
  [ROUTES.INVOICES]: { no: '/fakturaer', fi: '/laskut' },
  [ROUTES.PRICE_AND_COST]: { no: '/pris-og-kost', fi: '/hinta-ja-kustannukset' },
  [ROUTES.USAGE_SITES]: { no: '/maalepunkter', fi: '/kayttopaikat' },
  [ROUTES.FORECAST]: { no: '/forecast' }, // TODO: Change to Norwegian translation
  [ROUTES.NEWS]: { no: '/nyheter', fi: '/uutiset' },
  [ROUTES.USER_PROFILE]: { no: '/brukerprofil', fi: '/kayttajaprofiili' },
  [ROUTES.USERS]: { no: '/brukere', fi: '/kayttajat' },
  [ROUTES.USER_INVITATION]: { no: '/bruker-invitasjon', fi: '/kutsukayttaja' },
  [ROUTES.REGISTER_USER]: '/registeruser',
} as const satisfies Record<Route, string | Partial<Record<Locale[number], string>>>;

export const routing = defineRouting({
  locales: locales,
  pathnames,
  defaultLocale: 'en-GB',
  localePrefix: { mode: 'always', prefixes: { 'en-GB': '/en' } },
});
